/**
 * 配車板 車両一括並び替え (#3162) のソートキー定義。
 *
 * 信源: docs/change-designs/issues/3162-truck-bulk-sort/00-overview.md §3.2
 * mock v4: logi-go-mock/src/issues/3162-truck-bulk-sort/0-final-v4/types.ts
 *
 * K-1〜K-7 の 7 ソートキー (5/13 MTG 確定)。
 * 「など」追加候補 (車両コード / 車庫 / デフォルト運転手 / パートナーコード) は本件スコープ外。
 */
import { LABELS } from '@/constants/common/message.constants'

export const SORT_KEYS = {
  K1_NAME: 'K1_NAME',
  K2_TRUCK_CLASS: 'K2_TRUCK_CLASS',
  K3_TRUCK_ATTRIBUTE: 'K3_TRUCK_ATTRIBUTE',
  K4_PARTNER_NAME: 'K4_PARTNER_NAME',
  K5_SUB_PARTNER: 'K5_SUB_PARTNER',
  K6_MAX_LOAD_CAPACITY: 'K6_MAX_LOAD_CAPACITY',
  K7_MASTER_ORDER: 'K7_MASTER_ORDER'
} as const

export type SortKey = (typeof SORT_KEYS)[keyof typeof SORT_KEYS]

export const SORT_KEY_LABELS: Record<SortKey, string> = {
  [SORT_KEYS.K1_NAME]: LABELS.SORT_KEY_TRUCK_NAME,
  [SORT_KEYS.K2_TRUCK_CLASS]: LABELS.SORT_KEY_TRUCK_CLASS,
  [SORT_KEYS.K3_TRUCK_ATTRIBUTE]: LABELS.SORT_KEY_TRUCK_ATTRIBUTE,
  [SORT_KEYS.K4_PARTNER_NAME]: LABELS.SORT_KEY_PARTNER_NAME,
  [SORT_KEYS.K5_SUB_PARTNER]: LABELS.SORT_KEY_SUB_PARTNER,
  [SORT_KEYS.K6_MAX_LOAD_CAPACITY]: LABELS.SORT_KEY_MAX_LOAD_CAPACITY,
  [SORT_KEYS.K7_MASTER_ORDER]: LABELS.SORT_KEY_MASTER_ORDER
}

export const ALL_SORT_KEYS: SortKey[] = [
  SORT_KEYS.K1_NAME,
  SORT_KEYS.K2_TRUCK_CLASS,
  SORT_KEYS.K3_TRUCK_ATTRIBUTE,
  SORT_KEYS.K4_PARTNER_NAME,
  SORT_KEYS.K5_SUB_PARTNER,
  SORT_KEYS.K6_MAX_LOAD_CAPACITY,
  SORT_KEYS.K7_MASTER_ORDER
]

/**
 * ソート方向。
 * - 'asc' / 'desc' = アクティブ
 * - 'custom' = ソートキーボタン未押下、または D&D / リセット / ソートキー変更直後
 */
export type SortDirection = 'asc' | 'desc' | 'custom'
